export default ['*Email', '*First Name', '*Last Name', '*Amount', 'Notes'];
